import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { catchError, lastValueFrom, Observable, of, Subject, throwError } from 'rxjs';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SecureSessionService } from './secure-session.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  schoolId:any;
  sessionData:any;
  academicYearId: any;
  
  // Subject to notify school details update
  private schoolDetailsUpdated = new Subject<void>();
  public schoolDetailsUpdated$ = this.schoolDetailsUpdated.asObservable();
  
  private _designationCreateUrl="Designation/create-designation";
  private _designationListUrl="Designation/get-all-designation";
  private _designationUpdateUrl="Designation/update_class";
  private _designationDeleteUrl="Designation/delete_designation";
  private _designationById="Designation/get-designation-by-id";

  // private _departmentById="Department/get-departments-of-school";
  private _departmentCreateUrl="Department/Add-department";
  private _departmentListUrl="Department/get-departments-of-school";
  private _departmentUpdateUrl="Department/update-department";
  private _departmentDeleteUrl="Department";


  private _academicStageCreateUrl="Academicstage/create-academic-stage";
  private _academicStageListUrl="Academicstage/get-all-academic-stages";
  private _academicStageById="Academicstage/get-academic-stage-by-Id";
  private _academicStageUpdateUrl="Academicstage/update-stage";
  private _academicStageDeleteUrl="Academicstage/delete-stage";
  private _getAllClassesUnderAcademicStageUrl="Classes/get-classes-by-stage";


  private _streamCreateUrl="Schoolstream/create-stream";
  private _streamListUrl="Schoolstream/get-stream-by-schoolId";
  private _streamUpdateUrl="Schoolstream/update-stream";
  private _streamDeleteUrl="Schoolstream/delete-stream";
  private _streamById="Schoolstream/get-stream-by-Id";

  private _subjectByAcademicStage="Subject/get-subjects-by-academicstage";

  private _subjectById="Subject/get-sub-by-id";
  private _subjectCreateUrl="Subject/create-sub";
  private _subjectListUrl="Subject/get-all-sub";
  private _subjectUpdateUrl="Subject/update-sub";
  private _subjectDeleteUrl="Subject/delete-sub";
  private _updatePracticalName = "Subject/update-practical-name"
  private _roleList="Administrative/GetRoles";
  private _getClassSubjectUrl="Classes/get-subjects-in-class";
  private _getDivisionsUrl = "Classes/get-division-by-class";
  private _getAllStream = "Schoolstream/get-streams-by-academicstage";
  private _getHolidayUrl = 'Holidays/get-all'

 
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  
  constructor(private http:HttpClient,private _config:ConfigService,
    private _snackBar: MatSnackBar,private session:SecureSessionService) {
      this.sessionData=JSON.parse(this.session.getSession());
      console.log(this.sessionData);
      console.log("this is session data");
      if(this.sessionData)
      {
        this.schoolId=this.sessionData[0].schoolId;
        // temp
        this.academicYearId = this.sessionData[0].academicYearId;
      }
      
     }
  
 

  getDesignation(): Observable<any> {
    this.schoolId=this.sessionData[0].schoolId;
    console.log(this.schoolId);
    return this.http.get<any>(this._config._url+this._designationListUrl+'/'+this.schoolId).pipe(
      catchError(this.handleError)
    );
  }

  getClassSubjects(classId:any): Observable<any> {
    return this.http.get<any>(this._config._url+this._getClassSubjectUrl+'/'+classId+'/'+this.schoolId).pipe(
      catchError(this.handleError)
    );
  }

  getClassDivisions(classId:any):Observable<any> {
    return this.http.get<any>(this._config._url + this._getDivisionsUrl +'/'+classId).pipe(
      catchError(this.handleError)
    )
  }

  createDesignation(designation:any) {
    return this.http.post<any>(this._config._url+this._designationCreateUrl,designation).pipe(
      catchError(this.handleError)
    );
  }
 

  getDesignationById(id:any): Observable<any> {
    return this.http.get<any>(this._config._url+this._designationById+'/'+id).pipe(
      catchError(this.handleError)
    );
  }
  getSubjectById(id:any): Observable<any> {
    return this.http.get<any>(this._config._url+this._subjectById+'/'+id).pipe(
      catchError(this.handleError)
    );
  }

  getSubject(): Observable<any> {
    this.schoolId=this.sessionData[0].schoolId;
    console.log(this.schoolId);
    return this.http.get<any>(this._config._url+this._subjectListUrl+'/'+this.schoolId).pipe(
      catchError(this.handleError)
    );
  }
  createSubject(subject:any): Observable<any> {
    return this.http.post<any>(this._config._url+this._subjectCreateUrl,subject).pipe(
      catchError(this.handleError)
    );
  }
  updateSubject(subject:any,id:any): Observable<any> {
    return this.http.put<any>(this._config._url+this._subjectUpdateUrl+"/"+id,subject).pipe(
      catchError(this.handleError)
    );
  }



  //  getSubjectById(id:any): Observable<any> {
  //   return this.http.get<any>(this._config._url+this._subjectById+'/'+id).pipe(
  //     catchError(this.handleError)
  //   );
  // }
  private resolveSchoolIdFromSession(): any {
    const rawSession = this.session.getSession();
    let parsedSession: any = rawSession;

    if (typeof rawSession === 'string') {
      try {
        parsedSession = JSON.parse(rawSession);
      } catch {
        parsedSession = null;
      }
    }

    const schoolId = Array.isArray(parsedSession)
      ? parsedSession[0]?.schoolId
      : parsedSession?.schoolId;

    return schoolId ?? this.schoolId;
  }

  getHolidayList(): Observable<any> {
    const schoolId = this.resolveSchoolIdFromSession();

    if (schoolId === undefined || schoolId === null || schoolId === '') {
      return throwError(() => new Error('School ID not available in session.'));
    }

    return this.http
      .get<any>(`${this._config._url}${this._getHolidayUrl}/${schoolId}`)
      .pipe(catchError(this.handleError));
  }

  getDepartment(): Observable<any> {
    this.schoolId=this.sessionData[0].schoolId;
    console.log(this.schoolId);
    return this.http.get<any>(this._config._url+this._departmentListUrl+'/'+this.schoolId).pipe(
      catchError(this.handleError)
    );
  }
  createDepartment(department:any): Observable<any> {
    return this.http.post<any>(this._config._url+this._departmentCreateUrl,department).pipe(
      catchError(this.handleError)
    );
  }
 updateDepartment(department: any, id: any): Observable<any> {
  const schoolId = this.sessionData[0].schoolId;

  const url = `${this._config._url}${this._departmentUpdateUrl}?schoolId=${schoolId}&departmentId=${id}`;

  return this.http.put<any>(url, department).pipe(
    catchError(this.handleError)
  );
}


  deleteDepartment(id:any): Observable<any> {
    return this.http.delete<any>(this._config._url+this._departmentDeleteUrl+'/'+id).pipe(
      catchError(this.handleError)
    );
  }






  getacademicStage(schoolId?:any): Observable<any> {
  const freshSession = JSON.parse(this.session.getSession());
  const resolvedSchoolId = freshSession?.[0]?.schoolId ?? schoolId ?? this.schoolId;
  const url = `${this._config._url+this._academicStageListUrl}`;
  const params = { schoolId: resolvedSchoolId };

  return this.http.get<any>(url, { params }).pipe(
    catchError(this.handleError)
  );
}


getAllClassesUnderAcademicStage(id:any): Observable<any> {
  const url = `${this._config._url+this._getAllClassesUnderAcademicStageUrl}`;

  return this.http.get<any>(url+"/"+id).pipe(
    catchError(this.handleError)
  );
}

  getAllStream(id: any, schoolId:any): Observable<any> {
    const params = {
      academicStageId: id,
      schoolId: schoolId
    }
    const url = `${this._config._url + this._getAllStream}`;
    return this.http.get<any>(url, { params }).pipe(
      catchError((error) => {
        return of([]);
      })
    );
  }

  // Add a separate async function that converts to Promise
  async getAllStreamAsync(id: any, schoolId:any): Promise<any> {
    try {
      const result = await lastValueFrom(this.getAllStream(id, schoolId));
      return result || [];
    } catch (error) {
      return [];
    }
  }

  createacademicStage(academicStage:any): Observable<any> {
    return this.http.post<any>(this._config._url+this._academicStageCreateUrl,academicStage).pipe(
      catchError(this.handleError)
    );
  }
 updateacademicStage(academicStage: any, id: any): Observable<any> {
  const schoolId = this.sessionData[0].schoolId;

  const url = `${this._config._url}${this._academicStageUpdateUrl}?schoolId=${schoolId}&id=${id}`;

  return this.http.put<any>(url, academicStage).pipe(
    catchError(this.handleError)
  );
}


  deleteacademicStage(id:any): Observable<any> {
    return this.http.delete<any>(this._config._url+this._academicStageDeleteUrl+'/'+id).pipe(
      catchError(this.handleError)
    );
  }


 getacademicStageById(id:any): Observable<any> {
    // return this.http.get<any>(this._config._url+this._academicStageById+'/'+id).pipe(
    //   catchError(this.handleError)
    // );
    const url = `${this._config._url+this._academicStageById}`;
  const params = { Id: id };

  return this.http.get<any>(url, { params }).pipe(
    catchError(this.handleError)
  );
  }



   getStream(): Observable<any> {


    this.schoolId = this.sessionData[0].schoolId;
  console.log(this.schoolId);

  const url = `${this._config._url+this._streamListUrl}`;
  const params = { schoolId: this.schoolId };

  return this.http.get<any>(url, { params }).pipe(
    catchError(this.handleError)
  );
  }
  createStream(stream:any): Observable<any> {
    return this.http.post<any>(this._config._url+this._streamCreateUrl,stream).pipe(
      catchError(this.handleError)
    );
  }
 updateStream(stream: any, id: any): Observable<any> {
  const schoolId = this.sessionData[0].schoolId;

  const url = `${this._config._url}${this._streamUpdateUrl}?schoolId=${schoolId}&id=${id}`;

  return this.http.put<any>(url, stream).pipe(
    catchError(this.handleError)
  );
}


  deleteStream(id:any): Observable<any> {
    return this.http.delete<any>(this._config._url+this._streamDeleteUrl+'/'+id).pipe(
      catchError(this.handleError)
    );
  }
 getStreamId(id:any): Observable<any> {

    const url = `${this._config._url+this._streamById}`;
  const params = { Id: id };

  return this.http.get<any>(url, { params }).pipe(
    catchError(this.handleError)
  );
  }



  updateDesignation(designation:any,id:any): Observable<any> {
    return this.http.put<any>(this._config._url+this._designationUpdateUrl+"/"+id,designation).pipe(
      catchError(this.handleError)
    );
  }
  

  getRoles(): Observable<any> {
    return this.http.get<any>(this._config._url+this._roleList).pipe(
      catchError(this.handleError)
    );
  }

  openSnackBar(msg:string) {
    const snackBarRef= this._snackBar.open(msg, 'Close', {
       horizontalPosition: this.horizontalPosition,
       verticalPosition: this.verticalPosition,
       duration: 2000,
       panelClass: ['blue-snackbar']
     });
   
   }
   openSnackBarError(msg:string) {
    const snackBarRef= this._snackBar.open(msg, 'Close', {
       horizontalPosition: this.horizontalPosition,
       verticalPosition: this.verticalPosition,
       duration: 5000,
       panelClass: ['red-snackbar']
     });

   }

   deleteDesignation(id:any): Observable<any> {
    return this.http.delete<any>(this._config._url+this._designationDeleteUrl+'/'+id).pipe(
      catchError(this.handleError)
    );
  }

  deleteSubject(id:any): Observable<any> {
    return this.http.delete<any>(this._config._url+this._subjectDeleteUrl+'/'+id).pipe(
      catchError(this.handleError)
    );
  }

  updatePracticalName(requestBody:any): Observable<any>{
    return this.http.put<any>(this._config._url+this._updatePracticalName, requestBody).pipe(
      catchError(this.handleError)
    )
  }

   getSubjectsByAcademicStage(id:any): Observable<any> {
    
    return this.http.get<any>(this._config._url+this._subjectByAcademicStage+'/'+id).pipe(
      catchError(this.handleError)
    );
  }

//  handleError(error: HttpErrorResponse): Observable<never> {
//     let errorMessage = '';
//     let validationMessages: string[] = [];

//     // Log the full error to inspect its structure
//     console.error('Full error response:', error);

//     // Check for client-side error
//     if (error.error instanceof ErrorEvent) {
//       errorMessage = `Client-side error: ${error.error.message}`;
//     } else {
//       // Handle 409 Conflict error globally (regardless of the specific error message)
//       if (error.status === 409 && error.error) {
//         // If the error has a general message or specific errormessage, use it
//         errorMessage = `Conflict: ${error.error.message ||
//           error.error.errormessage ||
//           'Unknown conflict error'
//           }`;
//       }
//       // Handle 400 errors (validation errors)
//       else if (error.status === 400 && error.error) {
//         if (error.error.errors) {
//           // If it's an object, it could contain detailed validation messages
//           for (const field in error.error.errors) {
//             if (error.error.errors.hasOwnProperty(field)) {
//               // Add each field's validation message to the list
//               validationMessages.push(
//                 `${field}: ${error.error.errors[field].join(', ')}`
//               );
//             }
//           }
//         } else {
//           // Handle if no specific validation errors but just a general message
//           validationMessages.push(
//             error.error.message || 'Unknown validation error'
//           );
//         }

//         // Combine validation messages
//         errorMessage =
//           validationMessages.join(' | ') || 'Unknown validation error';
//       }
//       // Handle 404 Not Found error
//       else if (error.status === 404 && error.error) {
//         // If the error contains a message object like { "message": "Error in name field" }
//         errorMessage = `Not Found: ${error.error.message || 'Resource not found'
//           }`;
//       } else {
//         // Handle other server-side errors
//         errorMessage = `${error.error.message}`;
//       }
//     }
//     // Log the final error message
//     console.error('Processed error message:', errorMessage);

//     // Return the error message as an observable
//     return throwError(() => new Error(errorMessage));
//   }
// handleError(error: HttpErrorResponse): Observable<never> {
//   let errorMessage = '';
//   let validationMessages: string[] = [];

//   // Full error logging for debugging
//   console.error('Full error response:', error);

//   if (error.error instanceof ErrorEvent) {
//     // Client-side error
//     errorMessage = `Client-side error: ${error.error.message}`;
//   } else {
//     // Server-side error handling
//     switch (error.status) {
//       case 400:
//         if (error.error) {
//           // Case 1: If error has a validation error object (typical .NET or API format)
//           if (error.error.errors) {
//             for (const field in error.error.errors) {
//               if (error.error.errors.hasOwnProperty(field)) {
//                 const messages = error.error.errors[field];
//                 validationMessages.push(`${field}: ${messages.join(', ')}`);
//               }
//             }
//             errorMessage = validationMessages.join(' | ');
//           }
//           // Case 2: If error has a single `errorMessage` field (like your StageId example)
//           else if (error.error.errorMessage) {
//             errorMessage = error.error.errorMessage;
//           }
//           // Case 3: Fallback if only a `message` exists
//           else if (error.error.message) {
//             errorMessage = error.error.message;
//           } else {
//             errorMessage = 'Unknown validation error.';
//           }
//         }
//         break;

//       case 404:
//         errorMessage = `Not Found: ${error.error?.message || 'Resource not found'}`;
//         break;

//       case 409:
//         errorMessage = `Conflict: ${error.error?.message || error.error?.errormessage || 'Conflict occurred.'}`;
//         break;

//       default:
//         errorMessage = error.error?.message || `Error Code: ${error.status}`;
//         break;
//     }
//   }

//   // Final error message logging
//   console.error('Processed error message:', errorMessage);

//   return throwError(() => new Error(errorMessage));
// }
handleError(error: HttpErrorResponse): Observable<never> {
  let errorMessage = '';
  const validationMessages: string[] = [];

  // Full error logging for debugging
  console.error('Full error response:', error);

  if (error.error instanceof ErrorEvent) {
    // Client-side/network error
    errorMessage = `Client-side error: ${error.error.message}`;
  } else {
    // Server-side error
    switch (error.status) {
      case 400:
        if (error.error) {
          if (error.error.errors) {
            for (const field in error.error.errors) {
              if (error.error.errors.hasOwnProperty(field)) {
                const messages = error.error.errors[field];
                validationMessages.push(`${field}: ${messages.join(', ')}`);
              }
            }
            errorMessage = validationMessages.join(' | ');
          } else if (error.error.errorMessage) {
            errorMessage = error.error.errorMessage;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          } else if (error.error.errormessage) {
            errorMessage = error.error.errormessage;
          } else {
            errorMessage = 'Validation failed.';
          }
        }
        break;

      case 404:
        errorMessage = error.error?.errormessage || error.error?.message || 'Resource not found.';
        break;

      case 409:
        errorMessage = error.error?.errormessage || error.error?.message || 'Conflict occurred.';
        break;

      default:
        errorMessage = error.error?.errormessage || error.error?.message || `Error Code: ${error.status}`;
        break;
    }
  }

  // Log final error message
  console.error('Processed error message:', errorMessage);

  // Pass the error message to wherever the error is handled (e.g., a toast/snackbar)
  return throwError(() => new Error(errorMessage));
}


sortClassesByName(classes: any[]): any[] {
  return classes.sort((a, b) => {
    const nameA = a.name?.trim() ?? '';
    const nameB = b.name?.trim() ?? '';

    const numA = Number(nameA);
    const numB = Number(nameB);

    const isNumericA = !isNaN(numA);
    const isNumericB = !isNaN(numB);

    // Both are numeric — sort numerically
    if (isNumericA && isNumericB) {
      return numA - numB;
    }

    // One is numeric, one is text — put text before numeric
    if (!isNumericA && isNumericB) return -1;
    if (isNumericA && !isNumericB) return 1;

    // Both are text — sort alphabetically
    return nameA.localeCompare(nameB);
  });
}

// Notify components that school details have been updated
notifySchoolDetailsUpdated() {
  this.schoolDetailsUpdated.next();
}

}
